// TODO: Investigate why we need to turn this off in this file
/* eslint-disable react/require-default-props */
import React, { FC, useState } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import handleKeyPress from '../../common/handleKeyPress';
import * as Styled from './styles';

import Portal from '../Portal';

type TypeMap = {
    INFO: string;
    WARNING: string;
    ERROR: string;
};

type IconTypeMap = {
    INFO: IconProp;
    WARNING: IconProp;
    ERROR: IconProp;
};

interface IProps {
    type: keyof TypeMap;
    message: string;
    link?: string;
    linkTitle?: string;
}

export const MESSAGE_TYPE_MAP: TypeMap = {
    INFO: 'INFO',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
};

const ICON_NAME_MAP: IconTypeMap = {
    INFO: 'exclamation-circle',
    WARNING: 'exclamation-triangle',
    ERROR: 'times-octagon',
};

const Notifier: FC<IProps> = ({ type = 'INFO', message, link = '', linkTitle = '' }) => {
    const [visible, setVisible] = useState(true);

    if (!visible) {
        return null;
    }

    return (
        <Portal>
            <Styled.NotifierWrapper>
                <Styled.NotifierBox type={type}>
                    <Styled.Icon icon={ICON_NAME_MAP[type]} type={type} />
                    {message}
                    &nbsp;
                    {link && (
                        <a href={link} target="_blank" rel="noopener noreferrer">
                            {linkTitle}
                        </a>
                    )}
                    <Styled.CloseIcon
                        type={type}
                        icon="times"
                        onClick={() => setVisible(false)}
                        onKeyDown={(e) =>
                            handleKeyPress(e as unknown as React.KeyboardEvent<HTMLElement>, () => setVisible(false))
                        }
                    />
                </Styled.NotifierBox>
            </Styled.NotifierWrapper>
        </Portal>
    );
};

export default Notifier;
